<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
        采购单管理
      <small>/添加采购单</small>
    </h1>

    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
    <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">/添加采购单</h4>
              </div>
              <!-- begin panel-body -->
              <div class="panel-body">
              <el-form :inline="true"  ref="ruleForm" style="text-align:left;margin-top:16px;margin-bottom:20px;border-bottom :1px dashed #6a7786" class="formStyle">
                 
                  <el-form-item label="合同编号"  prop="contractNo" :rules="[{ required: true, message: '请选择合同编号', trigger:'blur'}]">
                    <el-select v-model="contractNo"   placeholder="请选择" style="width:100%">
                      <el-option
                        v-for="item in contractNoList"
                        :key="item.contractNo"
                        :label="item.contractNo"
                        :value="item.contractNo">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="合同标题" prop="contractNo" :rules="[{ required: true, message: '请选择合同标题', trigger:'blur'}]">
                    <el-select v-model="contractNo" placeholder="请选择" style="width:100%">
                      <el-option
                        v-for="item in contractNoList"
                        :key="item.contractNo"
                        :label="item.contractTitle"
                        :value="item.contractNo">
                      </el-option>
                    </el-select>
                  </el-form-item>
                   <el-form-item label="采购单总额" prop="outputNo" :rules="[{ required: true, message: '采购单总额', trigger:'blur'}]">
                    <el-input v-model="orderPrice" placeholder="采购单总额"></el-input>
                    <div class="ErrorTip" v-if="orderPriceErrorTip">只能输入数字</div>
                  </el-form-item>

                  <el-form-item label="上传凭证" prop="">
                    <el-upload 
                      class="avatar-uploader"
                      action
                      :show-file-list="false"
                      :http-request="uploadPicture">
                      <img v-if="imageUrl" :src="imageUrl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-progress :percentage="percentage" :status="percentagestatus" v-if="percentageShow"></el-progress> 
                    <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传图片</span>
                  </el-form-item>
                    <a class="btn btn-primary m-r-5 " style="color:#fff;float:right;" @click="submitForm('ruleForm')">提交</a>
                </el-form>
                <form class="MarginTop">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">商品名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          title=""
                          :data="GoodList"
                          key-field="goodsId"
                          show-field="goodsName"
                          placeholder="商品名称"
                          v-model="goodsId"
                          @values="singleValues"
                        ></v-selectpage>
                        <div
                          class="GoodsTip"
                          v-if="GoodShow"
                        >请选择货物</div>
                      </div>
                      <label class="col-md-1 col-form-label">商品数量</label>
                      <div class="col-md-2">
                        <input
                          type="number"
                          class="form-control"
                          placeholder="商品数量"
                          v-model="detailCount"
                          @change="NumberChange"
                          @keyup="detailCount=detailCount.toString().replace(/[^0-9]/g,'')"
                          @paste="detailCount=detailCount.toString().replace(/[^0-9]/g,'')"
                        >
                        <div
                          class="GoodsTip"
                          v-if="NumberShow"
                        >请输入大于0的整数</div>
                      </div>
                       <label class="col-md-1 col-form-label">备注</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="备注"
                          v-model="note"
                        >
                        <div
                          class="GoodsTip"
                          v-if="NumberShow"
                        >请输入大于0的整数</div>
                      </div>
                        <div class="col-md-11 MarginTop " style="margin-left: 135px">
                        <!-- <a  class="btn btn-primary m-r-5" style="float:right;color:white !important" @click="submit">提交</a> -->
                        <a  class="btn btn-primary m-r-5" style="float:right;color:white !important" @click="AddGoods">新增</a>
                      </div>

                      <div class="form-group row m-b-15"></div>
                    </div>
                  </fieldset>
                </form>
                <div class="ReceiptTitle"></div>
                <ul>
                  <li class="ReceiptTableTitle">商品名称</li>
                  <li class="ReceiptTableTitle">商品数量</li>
                  <li class="ReceiptTableTitle">备注</li>
                  <li
                    class="ReceiptTableTitle"
                    style="width:19%;min-width:200px;"
                  >操作</li>
                </ul>
                <ul
                  v-for="(item,index) in TableContent"
                  :key="index"
                >
                  <li class="ReceiptTableContent">{{item.goodsName}} </li>
                  <li class="ReceiptTableContent">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="请输入数量"
                      v-model.number="item.detailCount"
                      @input="GoodChange(index,item)"
                      @keyup="item.detailCount=item.detailCount.toString().replace(/[^0-9]/g,'')"
                      @paste="item.detailCount=item.detailCount.toString().replace(/[^0-9]/g,'')"
                    >
                  </li>
                  <li class="ReceiptTableContent">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="请输入数量"
                      v-model.number="item.note"
                    >
                  </li>
                  <li
                    class="ReceiptTableContent"
                    style="width:19%;min-width:200px;"
                  >
                        <a
                      class="btn btn-warning btn-sm ButtonColor"
                      @click="DeleteClick(item,index)"
                    >删除</a>                

                  </li>
                </ul>
              </div>
              <!-- end panel-body -->
              <div style="height:66px;padding-top:16px;padding-right:15px;">
                 
                <a class="btn btn-primary m-r-5"
                  style="float:right;cursor:pointer;color:#fff !important"
                  @click="Goback"
                >返&nbsp;&nbsp;回</a>

                <span class="clear"></span>
              </div>

            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->

        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "PushWarehouseReceipt",
  name: "product",
  data() {
    var checkoutCount = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输出库数量"));
      }
      setTimeout(() => {
        let reg = /^[1-9]\d*|0$/g;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("出库数量格式不正确"));
        }
      }, 1000);
    };
    var checkoutCount = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^[1-9]\d*|0$/g;
        reg.test(value) ? callback() : callback(new Error("出库数量格式不正确"));
      }, 1000);
    };
    return {
      recomName: "",
      recomId:"",
      CloseShow: false,
      warehouseModel: "请选择",
      detailCount: "",
      goodsId :"",
      orderPrice:"",
      note:"",
      GoodList: [],
      recomList: [],
      manualId:"",
      percentageShow:false,
      percentagestatus:'exception',
      percentage:0,
      errorTip:false,
      orderPriceErrorTip:false,
      imageUrl:"",
      name:"",
      GoodShow: false,
      NumberShow: false,
      TableContent: [],
      warehouseList:[],
      contractNoList:[],
      contractNo:"",
      goodsName: "",
      ErrorShow: false,
      number: "",
      currentPage: 1,
      pageSize: 10,
      voucherPath:"",
      fileUrl:"",
      tableForm: {
        tableData3: [
          {
            outCount: ""
          }
        ]
      },
      tableRules: {
        outCount: [
          { required: true, message: "请输采购数量" },

          { validator: checkoutCount, trigger: ["change", "blur"] }
        ]
      },

      input: "",

      CurrentSelection: [],
      // 当前页  ---- 默认显示第几页
      // current: 1,
      //  缴纳时间
      value1: "",
      tableForm: {
        tableData3: [ ]
      },
      tableRules: {
        outCount: [
          { required: true, message: "请输入出库数量" },
          { validator: checkoutCount, trigger: ["change", "blur"] }
        ]
      },
      input: "",
      CurrentSelection: [],
      // 当前页  ---- 默认显示第几页
      // current: 1,
      //  缴纳时间
      value1: "",
      pageNo: 1,
      PushWarehouseReceiptEdit: {
        id: "",
        number: ""
      }
    };
  },
  mounted: function() {
    this.getGoodsInfo();
  },
  methods: {
    NumberChange() {
      if (this.detailCount < 2) {
        this.detailCount = 1;
      }
    },
    GoodChange(index, item) {
      if (item.count < 2) {
        item.count = 1;
      }
      this.$set(this.TableContent, index, item);
    },
    Goback() {
      this.$router.push({
        name: "top",
        params: { pageNo: this.pageNo, pagesize: this.pageSize }
      });
    },

    //获取商品
    getGoodsInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/queryGoodsInfoByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.GoodList = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    // 图片上传
    uploadPicture(param) {
      this.imageUrl = URL.createObjectURL(param.file);
      const formData = new FormData();
      formData.append("file", param.file);
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.voucherPath = response.data.data;
          that.percentageShow =  true;
          setTimeout(()=>{
            that.percentage = 100;
            that.percentagestatus = "success"
          },100)
        } else {
          http.handleEorrorCode(response,that);
        }
      }).catch(function(error) {
        http.handleHttpError(error, that);
      });
    }, 

    EnterSelect() {
      if (this.warehouseModel !== "请选择") {
        this.CloseShow = true;
      }
    },
    LeaveSelect() {
      this.CloseShow = false;
    },
    ClearSelect() {
      this.warehouseModel = "请选择";
      this.CloseShow = false;
    },
    edit(item) {
      this.ShipperEdit = item;
    },
    // gooslist分页
    singleValues(val) {
      if (val.length !== 0) {
        this.goodsName = val[0].goodsName;
        this.goodsId = String(val[0].goodsId);
      }
    },
// 获取合同编号
    getContractList() {
      let that = this;
      const options = {
        url: "distribution/B2cTobContractController/selectContractList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.contractNoList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
   //提交
    submitForm() {
      this.ValidForm();
      let that = this;
      let totalcount = 0;
      if (this.TableContent.length === 0) {
        this.$notify({
          title: "失败",
          message: "请先新增一条商品",
          type: "error"
        });
      } else {
        this.TableContent.forEach(val => {
          totalcount = Number(val.count) + totalcount;
        });
      }
      this.TableContent.forEach(element => {
        element.detailCount = element.detailCount.toString();
      });
      if (
        this.TableContent.length !== 0 &&
         !this.errorTip && 
        this.orderPrice !==''
      ) {
        const options = {
         url: "/distribution/B2cTobOrderController/addorder",
          method: "post",
          headers: { "Content-Type": "application/json" },
          data: {
            fileUrl: that.voucherPath,
            detailCount:22,
            orderPrice:that.orderPrice,
            contractNo:that.contractNo,
            orderInfos:  JSON.parse(JSON.stringify(that.TableContent))
          }
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
              that.$router.push({ path: "/top" });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(error => {
            http.handleHttpError(error, that);
          });
      }
    },
 // gooslist分页
    warehouseValues(val) {
      if (val.length !== 0) {
        this.manualId = val[0].manualId;
        this.name = val[0].name;
      }
    },
    
    recomValues (val) {
      if (val.length !== 0) {
        this.recomName = val[0].id;
        this.recomId = String(val[0].recomId);
      }
    },
    ChangeSelect() {
      this.number = 1;
      if (this.goodsName != "") {
        this.GoodShow = false;
      } else {
        this.GoodShow = true;
      }
    },
    ValidForm() {
    
  if (this.voucherPath === '') {
        this.errorTip = true;
      } else {
        this.errorTip = false;
      }
  if (this.orderPrice === '') {
        this.orderPriceErrorTip = true;
      } else {
        this.orderPriceErrorTip = false;
      }
      
    },


    //删除
    DeleteClick(item, index) {
      this.TableContent.forEach((val, index1) => {
        if (index === index1) {
          this.TableContent.splice(index, 1);
        }
      });
      localStorage.removeItem("userInput");
    },

    //新增
    AddGoods() {
      let reg = /^[1-9]\d*$/g;
      let currentGoods = "";
      this.TableContent.forEach(val => {
        if (val.goodsId === this.goodsId && val.recomId === this.recomId) {
          currentGoods = val.goodsId;
          this.$notify({
            title: "失败",
            message: "该商品已经选择",
            type: "error"
          });
        }
      });
      if (
        this.goodsId !== "" &&
        this.detailCount !== "" &&
        currentGoods === ""
      ) {
        this.GoodShow = false;

        let arr = {};
        arr.goodsName = this.goodsName;
        arr.detailCount = this.detailCount;
        arr.goodsId = this.goodsId;       
        arr.note= this.note;
        this.TableContent.push(arr);
      } else if (this.goodsId === "" ) {
        this.GoodShow = true;
      } else if (!reg.test(this.detailCount)) {
        this.NumberShow = true;
      } 
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.TitleStyle {
  color: #6a7786;
}
.TableTd {
  padding: 0px;
  height: 49px;
  line-height: 49px;
}
.ShipperForm {
  border: 1px solid #d3d8de;
  box-shadow: none;
  font-size: 12px;
  line-height: 34px;
  height: 34px;
  border-radius: 0.25rem;
}
.clear {
  clear: both;
}
.ShipperFormLabel {
  width: 35%;
  float: left;
  font-size: 12px;
  line-height: 34px;
  height: 34px;
}
.ShipperFormContent {
  width: 65%;
  float: left;
}
.ShipperInput {
  width: 90%;
  margin: 0 auto;
}
.ShipperMargin {
  margin-bottom: 16px;
}
.MarginTop {
  margin-top: 16px;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}

.ReceiptTableTitle {
  list-style: none;
  float: left;
  color: #909399;
  padding: 12px 32px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  min-width: 300px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  width: 27%;
}
.ButtonColor {
  color: #fff !important;
}
.ReceiptTableContent {
  padding: 12px 32px;
  list-style: none;
  float: left;
  font-size: 14px;
  line-height: 24px;
  height: 54px;
  color: #606266;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  min-width: 300px;
  width: 27%;
  border: 1px solid #ebeef5;
}
.GoodsTip {
  color: red;
  text-align: left;
  font-size: 12px;
  line-height: 32px;
}

.ErrorTip {
  color: red;
  font-size: 12px;
  line-height: 24px;
  text-align: left;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/topOrderAddList.vue